import Action from './Action';

import { get, isEmpty } from "lodash";

import AuthorizationService from '../services/AuthorizationService';
import EventDispatcher from "../framework/EventDispatcher";
import Error from '../model/Error';

import { getLastSubscription } from "../pages/utils/SubscriptionUtils";

import UserAccountService from '../services/UserAccountService';
import * as InvoiceActions from '../actions/InvoiceActions';
import * as SubscriptionActions from '../actions/SubscriptionActions';
import * as BillingAccountActions from '../actions/BillingAccountActions';

export const GET_USERACCOUNT = "GET_USERACCOUNT";

export default function reducer (state ={}, action={}){
	switch (action.type) {
		case EventDispatcher.successAction(GET_USERACCOUNT): {
			const {userAccount} = action.data;
			return {
				...state,
				userAccount
			};
		}
		default:
		return state;
	}
}

export function loadUserAccount(resume) {
	return (dispatch, getState)=> {
		EventDispatcher.loading(dispatch, GET_USERACCOUNT);
		const {messages: mainMessages={}} = getState();
		const {messages = {}} = mainMessages || {};
		const {email: contactEmail} = AuthorizationService.auth.tokenParsed || {};
		if (!contactEmail) {
			resume(null, new Error({message: messages["common.error.connected.user.has.no.email"]}));
			return;
		}
		const params = {
			filters: {
				'contactInformation.email': contactEmail
			}
		};
		UserAccountService.findUserAccount(params)
			.then(response => {
				const {status} = response;
				if (status === null || status === "FAIL") {
					throw status;
				} else {
					const userAccountInfo = response.data || [];
					if (userAccountInfo.length == 0) {
						EventDispatcher.error(dispatch,  GET_USERACCOUNT, messages["common.error.contact.not.found"]);
						resume(null, new Error({message: messages["common.error.contact.not.found"]}));
						return;
					} else {
						const userAccount = userAccountInfo[0] || {};
						EventDispatcher.success(dispatch, GET_USERACCOUNT, {userAccount});
						const {subscriptions} = userAccount;
						const subscription = getLastSubscription(subscriptions);
						const {code: subscriptionCode = ""} = subscription;
						// SAVE LAST SUBSCRIPTION
						!!subscription && dispatch(SubscriptionActions.setSubscription(subscription));
						// LOAD INVOICES
						!!subscriptionCode && dispatch(InvoiceActions.fetchMyInvoices(subscriptionCode));
						// LOAD PROCEDURE
						const {cfValues={}} = subscription || {};
						const procedureID = get(cfValues, "valuesByCode.cf_YOUSIGN_PROC_ID.0.value", "");
						!!procedureID && dispatch(SubscriptionActions.getProcedure(procedureID));
						// LOAD CALENDAR INFOS
						const {billingAccount={}} = userAccount || {};
						const {billingCycle={}} = billingAccount || {};
						!isEmpty(billingCycle) && dispatch(BillingAccountActions.fetchCalendarInfo(billingCycle.code));
						// LOAD INVOICING DATES
						!!subscriptionCode && dispatch(InvoiceActions.fetchInvoicesDates(subscriptionCode));
						
						resume(userAccount, null);
					}
				}
			}).catch(error => {
				EventDispatcher.error(dispatch,  GET_USERACCOUNT, messages["common.error.contact.not.found"]);
				resume(null, error);
			})
	}
}



// WEBPACK FOOTER //
// ./src/opencell/actions/UserAccountActions.js